const request = {}

request.createRequest = function (productData) {
  return {
    productNumber: productData.productInfoLine1.productNumber,
    supplierId: productData.productInfoLine1.supplierId.value,
    makerName: productData.productDetailInfoLine1.makerName
      ? productData.productDetailInfoLine1.makerName
      : null,
    brandName: productData.productDetailInfoLine1.brandName
      ? productData.productDetailInfoLine1.brandName
      : null,
    productCategoryId: productData.productInfoLine1.categoryId,
    productImg: productData.productDetailInfoLine1.productImg
      ? productData.productDetailInfoLine1.productImg
      : null,
    productNameJp: productData.productInfoLine1.productNameJp,
    productNameCn: productData.productInfoLine1.productNameCn
      ? productData.productInfoLine1.productNameCn
      : null,
    taxExcludedRetailPriceCurrencyId:
      productData.productInfoLine1.taxExcludedRetailPriceCurrency.value,
    taxExcludedRetailPrice: productData.productInfoLine1.taxExcludedRetailPrice,
    purchasePriceCurrencyId:
      productData.productInfoLine1.purchasePriceCurrency.value,
    purchasePrice: productData.productInfoLine1.purchasePrice,
    taxId: productData.productInfoLine1.taxId,
    productHeight: productData.productDetailInfoLine1.productHeight
      ? productData.productDetailInfoLine1.productHeight
      : null,
    productWidth: productData.productDetailInfoLine1.productWidth
      ? productData.productDetailInfoLine1.productWidth
      : null,
    productDepth: productData.productDetailInfoLine1.productDepth
      ? productData.productDetailInfoLine1.productDepth
      : null,
    capacity: productData.productInfoLine2.capacity
      ? productData.productInfoLine2.capacity
      : null,
    weight: productData.productInfoLine2.weight
      ? productData.productInfoLine2.weight
      : null,
    cartonQuantity: productData.productDetailInfoLine1.cartonQuantity
      ? productData.productDetailInfoLine1.cartonQuantity
      : null,
    lotQuantity: productData.productInfoLine2.lotQuantity,
    packageHeight: productData.productDetailInfoLine1.packageHeight
      ? productData.productDetailInfoLine1.packageHeight
      : null,
    packageWidth: productData.productDetailInfoLine1.packageWidth
      ? productData.productDetailInfoLine1.packageWidth
      : null,
    packageDepth: productData.productDetailInfoLine1.packageDepth
      ? productData.productDetailInfoLine1.packageDepth
      : null,
    packageWeight: productData.productDetailInfoLine1.packageWeight
      ? productData.productDetailInfoLine1.packageWeight
      : null,
    gtinCode: productData.productInfoLine2.gtinCode
      ? productData.productInfoLine2.gtinCode
      : null,
    janCode: productData.productInfoLine2.janCode
      ? productData.productInfoLine2.janCode
      : null,
    titleCopyJp: productData.productDetailInfoLine1.titleCopyJp
      ? productData.productDetailInfoLine1.titleCopyJp
      : null,
    titleCopyCn: productData.productDetailInfoLine1.titleCopyCn
      ? productData.productDetailInfoLine1.titleCopyCn
      : null,
    catchCopyJp: productData.productDetailInfoLine2.catchCopyJp
      ? productData.productDetailInfoLine2.catchCopyJp
      : null,
    catchCopyCn: productData.productDetailInfoLine2.catchCopyCn
      ? productData.productDetailInfoLine2.catchCopyCn
      : null,
    bodyCopyJp: productData.productDetailInfoLine2.bodyCopyJp
      ? productData.productDetailInfoLine2.bodyCopyJp
      : null,
    bodyCopyCn: productData.productDetailInfoLine2.bodyCopyCn
      ? productData.productDetailInfoLine2.bodyCopyCn
      : null,
    url: productData.productInfoLine2.url
      ? productData.productInfoLine2.url
      : null,
    approvalAcquisition: productData.productDetailInfoLine2.approvalAcquisition
      ? productData.productDetailInfoLine2.approvalAcquisition
      : null,
    component: productData.productDetailInfoLine2.component
      ? productData.productDetailInfoLine2.component
      : null,
    alertPeriod: productData.productInfoLine2.alertPeriod
      ? productData.productInfoLine2.alertPeriod
      : null,
    isEnabled: productData.productInfoLine2.isEnabled,
    isEnabledPenguin: productData.productInfoLine2.isEnabledPenguin
  }
}
export default { request }
